// extracted by mini-css-extract-plugin
export var container = "_hn-0";
export var content = "_hn-3";
export var customerTitle = "_hn-4";
export var empty = "_hn-5";
export var gray = "_hn-6";
export var header = "_hn-7";
export var info = "_hn-8";
export var loading = "_hn-2";
export var loadingCard = "_hn-9";
export var oneLine = "_hn-a";
export var personName = "_hn-e";
export var pillContainer = "_hn-b";
export var selected = "_hn-1";
export var text = "_hn-c";
export var twoLines = "_hn-d";
export var unread = "_hn-f";
export var unreadIndicator = "_hn-g";